import type { GameModeDefinition } from "../levels/types";

export const deathmatchMode: GameModeDefinition = {
  id: "dm",
  name: "Deathmatch",
  shortLabel: "DM",
  description: "Free-for-all combat. First pilot to the frag limit wins.",
  teamBased: false,
  fragLimit: 25,
  timeLimitSeconds: 600,
};